import {Injectable} from '@angular/core';
import {HttpClient, HttpEventType} from '@angular/common/http';
import {FileDto, FileUploadProgressTypes, UploadProgress} from '../models/file';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {ConfigsLoaderService} from './config-loader.service';
import * as saveAs from 'file-saver';

@Injectable()
export class PublicFilesService {
  private apiEndPoint: string;
  private endpoint: string;
  constructor(private http: HttpClient,
              private config: ConfigsLoaderService) {
    this.apiEndPoint = this.config.apiUrl;
    
  }

  postFileWithProgress(file: FileDto, endpoint?:string): Observable<UploadProgress<FileDto>> {
    if(endpoint){
      this.endpoint = endpoint;
    } else{
      this.endpoint = 'File/UploadFile';
    }

    if(this.endpoint.includes('api/')){
      this.endpoint = this.endpoint.split('api/')[1];
    }

    return this.http
      .post<FileDto>(`${this.apiEndPoint}/${this.endpoint}`, file, {reportProgress: true, observe: 'events'})
      .pipe(
        map(ev => {
          switch (ev.type) {
            case HttpEventType.UploadProgress:
              return {
                status: FileUploadProgressTypes.UPLOADING,
                progress: (ev.loaded / ev.total) * 100,
              };
            case HttpEventType.Response:
              return {
                status: FileUploadProgressTypes.FINISHED,
                progress: 100,
                data: ev.body,
              };
            case HttpEventType.DownloadProgress:
              return {
                status: FileUploadProgressTypes.PROCESSING,
                progress: 101,
              };
            default:
              return {
                status: FileUploadProgressTypes.LOADING,
              };
          }
        })
      );
  }

  postFileSimple(file: FileDto, endpoint?:string): Observable<FileDto> {
    if(endpoint){
      this.endpoint = endpoint;
    } else{
      this.endpoint = 'Tenant/UploadFileTheme';
    }
    return this.http.post<FileDto>(`${this.apiEndPoint}/${this.endpoint}`, file);
  }

  downloadFileTemplate(templateId) {
    return this.http
      .get<{ data: string, mimeType: string, fileName: string }>(`${this.apiEndPoint}/File/GetFileDownloadDto/${templateId}`)
      .pipe(
        tap(data => {
          fetch(`data:${data.mimeType};base64,${data.data}`)
            .then(res => res.blob())
            .then(blob => saveAs(blob, data.fileName));
        }),
      );
  }

  getFileWithUrl(fileId: number): Observable<FileDto>{
    return this.http.get<FileDto>(`${this.apiEndPoint}/File/GetFileWithUrl/${fileId}`);
  }

  downloadFileDto(fileId) {
    return this.http
      .get<{ data: string, mimeType: string, fileName: string, url: string }>(`${this.apiEndPoint}/File/GetFileDownloadDto/${fileId}`)
      .pipe(
        tap(data => {
          return {
            data: `data:${data.mimeType};base64,${data.data}`,
            mimeType: data.mimeType,
            url: data.url
          };
        })
      )
  }
        
}
